import styled from 'styled-components/macro';

export const PlDataText = styled.span`
    font-weight: bold;
`;
